<template>
  <v-layout>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-flex>
      <Banner />
      <AboutUs />
      <SellerM />
      <FeaturedProducts />
      <Slider />
      <Blog />
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import Banner from "./homeBanner";
import AboutUs from "./homeAboutUs";
import FeaturedProducts from "./homeFeaturedProducts";
import Slider from "./slider";
import Blog from "./blog";
import SellerM from "./sellerHomepageMap.vue";
export default {
  components: {
    Banner,
    AboutUs,
    FeaturedProducts,
    Slider,
    Blog,
    SellerM,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
    };
  },
  beforeMount() {
    // alert(this.userRole)
    if (this.userRole) this.getUser();
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
  },
  methods: {
    getUser() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("userData", response.data.data);
            this.$store.commit("changeCart", response.data.cart_length);
            // this.$store.commit("userType", response.data.data.user.role);
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>